const serverlessOfflineModeSiteUrl = "http://localhost:3005";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  MAX_ATTACHMENT_SIZE: 5000000,

  s3: {
    REGION: "unused",
    BUCKET: "unused",
  },
  apiGateway: {
    REGION: "us-west-2",
    URL: "https://x4znzw6vl2.execute-api.us-west-2.amazonaws.com/dev",
  },
  eventsApiGateway: {
    REGION: "us-west-2",
    URL: "https://ns6nm29dn5.execute-api.us-west-2.amazonaws.com/dev",
  },
  cognito: {
    REGION: "us-west-2",
    USER_POOL_ID: "us-west-2_cZNraupab",
    APP_CLIENT_ID: "75ckfleoq2lt5l7re4nkmeb3c9",
    IDENTITY_POOL_ID: "us-west-2:bb575cfa-c23c-4b58-94ad-19d0ef6ccbbc",
  },
  dwolla: {
    environment: "sandbox",
    baseUrl: "https://api-sandbox.dwolla.com",
  },
  contentBaseUrl: "https://dev-taabl-filestore.s3-us-west-2.amazonaws.com",

  configs: [
    {
      STAGE: "dev",
      s3: {
        REGION: "unused",
        BUCKET: "unused",
      },
      apiGateway: {
        REGION: "us-west-2",
        URL: "https://x4znzw6vl2.execute-api.us-west-2.amazonaws.com/dev",
      },
      eventsApiGateway: {
        REGION: "us-west-2",
        URL: "https://ns6nm29dn5.execute-api.us-west-2.amazonaws.com/dev",
        // URL: "http://localhost:3001/dev",
      },
      cognito: {
        REGION: "us-west-2",
        USER_POOL_ID: "us-west-2_cZNraupab",
        APP_CLIENT_ID: "75ckfleoq2lt5l7re4nkmeb3c9",
        IDENTITY_POOL_ID: "us-west-2:bb575cfa-c23c-4b58-94ad-19d0ef6ccbbc",
      },
      dwolla: {
        environment: "sandbox",
        baseUrl: "https://api-sandbox.dwolla.com",
      },
      sqs: {
        URL: `https://sqs.us-west-2.amazonaws.com/039217148104/taabl-events-dev-sqs`
      },
      contentBaseUrl: "https://dev-taabl-filestore.s3-us-west-2.amazonaws.com",
      siteUrl: "http://localhost:3000",
      bank_integration: "dwolla", // dwolla
    },
    {
      //prod
      STAGE: "prod",
      s3: {
        REGION: "unused",
        BUCKET: "unused",
      },
      apiGateway: {
        REGION: "us-west-2",
        URL: "https://um8pfgnz53.execute-api.us-west-2.amazonaws.com/prod",
      },
      eventsApiGateway: {
        REGION: "us-west-2",
        URL: "https://847e9a832c.execute-api.us-west-2.amazonaws.com/prod",
      },
      cognito: {
        REGION: "us-west-2",
        USER_POOL_ID: "us-west-2_cpYAA3gyg",
        //user pool client ID
        APP_CLIENT_ID: "77ki9dmm8q7bkcc7fmjmahsuad",
        IDENTITY_POOL_ID: "us-west-2:d59cf33e-45fb-44f4-a62c-f5a48b68e283",
      },
      dwolla: {
        environment: "production",
        baseUrl: "https://api.dwolla.com",
      },
      sqs: {
        URL: `https://sqs.us-west-2.amazonaws.com/291894431619/taabl-events-prod-sqs`
      },
      contentBaseUrl: "https://prod-taabl-website.s3-us-west-2.amazonaws.com",
      siteUrl: "https://portal.taabl.co",
      bank_integration: "dwolla", // dwolla
    },
    {
      //qa
      STAGE: "qa",
      s3: {
        REGION: "unused",
        BUCKET: "unused",
      },
      apiGateway: {
        REGION: "us-west-2",
        URL: "https://v2i1ycnxwa.execute-api.us-west-2.amazonaws.com/qa",
      },
      eventsApiGateway: {
        REGION: "us-west-2",
        URL: "https://4e0rd0los5.execute-api.us-west-2.amazonaws.com/qa",
      },
      cognito: {
        REGION: "us-west-2",
        USER_POOL_ID: "us-west-2_4xtantox6",
        APP_CLIENT_ID: "11i05h15bqf92gt1p67kcc3svk",
        IDENTITY_POOL_ID: "us-west-2:8d121b37-f811-4456-806a-f914b36e68ed",
      },
      dwolla: {
        environment: "sandbox",
        baseUrl: "https://api-sandbox.dwolla.com",
      },
      sqs: {
        URL: `https://sqs.us-west-2.amazonaws.com/291894431619/taabl-events-qa-sqs`
      },
      googleAnalyticsId: "G-X8S4835R9E",
      contentBaseUrl: "https://qa-taabl-website.s3-us-west-2.amazonaws.com",
      siteUrl: "https://qa.taabl.co",
      bank_integration: "dwolla", // dwolla
    },

    {
      //demo
      STAGE: "demo",
      s3: {
        REGION: "unused",
        BUCKET: "unused",
      },
      apiGateway: {
        REGION: "us-west-2",
        URL: "https://2jnl03b6u8.execute-api.us-west-2.amazonaws.com/demo",
      },
      cognito: {
        REGION: "us-west-2",
        USER_POOL_ID: "us-west-2_TxFm9n5H0",
        //user pool client ID
        APP_CLIENT_ID: "5s0iucr46f8o69jm0dte9unm89",
        IDENTITY_POOL_ID: "us-west-2:7e326639-a2f5-4b0e-8f4c-fcad6cb83ed6",
      },
      dwolla: {
        environment: "sandbox",
        baseUrl: "https://api-sandbox.dwolla.com",
      },
      contentBaseUrl: "https://demo-taabl-filestore.s3-us-west-2.amazonaws.com",
      siteUrl: "https://demo.taabl.co",
    },
    {
      //devlan
      s3: {
        REGION: "unused",
        BUCKET: "unused",
      },
      apiGateway: {
        REGION: "us-west-2",
        URL: "https://j68nwv17j2.execute-api.us-west-2.amazonaws.com/devlan",
      },
      cognito: {
        REGION: "us-west-2",
        USER_POOL_ID: "us-west-2_HSumtIKAZ",
        //user pool client ID
        APP_CLIENT_ID: "5ijmh550atcbo01mj08du5956",
        IDENTITY_POOL_ID: "us-west-2:cf773b17-e40f-43df-b6c8-c8da42abd620",
      },
      contentBaseUrl: "https://devlan-taabl-website.s3-us-west-2.amazonaws.com",
      siteUrl: "https://devlan.taabldev.com",
    },
    {
      s3: {
        REGION: "unused",
        BUCKET: "unused",
      },
      apiGateway: {
        REGION: "us-west-2",
        URL: "http://localhost:3000/dev",
      },
      cognito: {
        REGION: "us-west-2",
        USER_POOL_ID: "us-west-2_cZNraupab",
        APP_CLIENT_ID: "75ckfleoq2lt5l7re4nkmeb3c9",
        IDENTITY_POOL_ID: "us-west-2:bb575cfa-c23c-4b58-94ad-19d0ef6ccbbc",
        AUTH_PROVIDER: "us-west-2:bb575cfa-c23c-4b58-94ad-19d0ef6ccbbc",
      },
      contentBaseUrl: "https://dev-taabl-filestore.s3-us-west-2.amazonaws.com",
      siteUrl: serverlessOfflineModeSiteUrl,
    },
  ],

  getConfigObject: function () {
    let loc = window.location.href;
    //loc = "https://devlan.taabl.co";
    for (var i = 0; i < this.configs.length; i++) {
      if (loc.startsWith(this.configs[i].siteUrl)) {
        // if attempting to run against serverless offline, make sure we have an AUTH_PROVIDER set
        if (
          this.configs[i].siteUrl === serverlessOfflineModeSiteUrl &&
          !this.configs[i].cognito.AUTH_PROVIDER
        ) {
          throw new Error(
            "To run against serverless offline, you must set your Identity Pool user ID as REACT_APP_AUTH_PROVIDER environment variable in your .env file: see https://serverless-stack.com/chapters/invoke-api-gateway-endpoints-locally.html"
          );
        }
        return this.configs[i];
      }
    }
    //this is the default config
    return this.configs[0];
  },
};
